import { combineReducers } from 'redux';
import { AsyncRequest } from 'angieslist-app-platform';
import advertisingActionKeys from './advertising-gateway/advertisingActionKeys';
import officeHomeActionKeys from './office-home-gateway/officeHomeActionKeys';

export default combineReducers({
  initialAgreement:
    AsyncRequest.createReducer(advertisingActionKeys.ADVERTISING_GET_INITIAL_AGREEMENT),
  getOpportunityOwners:
    AsyncRequest.createReducer(advertisingActionKeys.GET_OPPORTUNITY_OWNERS),
  fetchAgreementsByServiceProviderId:
    AsyncRequest.createReducer(advertisingActionKeys.FETCH_AGREEMENTS_BY_SERVICE_PROVIDER_ID),
  getBusinessInformation:
    AsyncRequest.createReducer(officeHomeActionKeys.OFFICE_HOME_GET_BUSINESS_INFORMATION),
  saveBusinessInformation:
    AsyncRequest.createReducer(officeHomeActionKeys.OFFICE_HOME_SAVE_BUSINESS_INFORMATION),
  getAccountOwner:
    AsyncRequest.createReducer(officeHomeActionKeys.OFFICE_HOME_GET_ACCOUNT_OWNER),
});



// WEBPACK FOOTER //
// ./src/modules/adAgreement/common/adAgreementReducer.js